// extracted by mini-css-extract-plugin
export var sbShowMain = "page-module--sb-show-main--5W1eh";
export var totaraLogo = "page-module--totaraLogo--fzPWB";